import { Moon, Sun } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { LanguageToggle } from './LanguageToggle'
import { AudioDevicePopover } from './AudioDevicePopover'

/**
 * Les réglages qu'on touche rarement (thème, langue, audio) en une rangée
 * d'icônes en bas de la barre, au lieu de trois lignes de menu.
 */
export function OutilsPerso({ darkMode, collapsed, onToggleDarkMode }: { darkMode: boolean; collapsed: boolean; onToggleDarkMode: () => void }) {
  const { t } = useTranslation()
  const bouton = cn(
    'flex items-center justify-center h-7 rounded-md transition-colors',
    darkMode ? 'text-slate-400 hover:bg-slate-800 hover:text-white' : 'text-slate-500 hover:bg-slate-100 hover:text-slate-900',
  )
  return (
    <div className={cn('flex items-center', collapsed ? 'flex-col gap-0.5' : 'justify-between px-1')}>
      <button
        type="button"
        onClick={onToggleDarkMode}
        title={darkMode ? t('sidebar.lightMode', 'Mode clair') : t('sidebar.darkMode', 'Mode sombre')}
        className={cn(bouton, 'w-8')}
      >
        {darkMode ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </button>
      <LanguageToggle collapsed={collapsed} darkMode={darkMode} compact={!collapsed} />
      <AudioDevicePopover collapsed darkMode={darkMode} compact />
    </div>
  )
}
